module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Deleted-file-c54e6a20240747169b0f4508f20ff69e.svg";